<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">岗位分类</div>
    </div>
    <div class="nav2">
<!--      <div class="tit1">-->
<!--        <el-button @click="AddFenlei" size="small" type="primary" icon="el-icon-plus">添加岗位分类</el-button>-->
<!--      </div>-->
      <div class="myForm">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item  label="二级分类：">
            <el-input
                    size="small"
                    v-model="searchForm.keyword"
                    placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="searchOnSubmit"
            >查找</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="myTable">
        <vxe-table ref="myTable2" :tree-config="{
          transform: true, line: true,rowField: 'id', parentField: 'parentId',
          lazy: true, hasChild: 'myis_child', loadMethod: loadChildrenMethod
        }"  resizable :data="tableData">
        <!-- <vxe-column type="seq" width="180" title="序号" tree-node></vxe-column> -->
          <vxe-table-column tree-node width="140" field="id" title="ID"></vxe-table-column>
          <vxe-table-column field="title" title="分类名称"></vxe-table-column>
          <vxe-table-column field="code" title="内部编码"></vxe-table-column>
          <vxe-table-column field="zhilian_names" title="关联智联"  style="line-height: normal"></vxe-table-column>
          <vxe-table-column field="sort" title="排序"></vxe-table-column>
          <vxe-table-column field="is_show" title="状态(是否显示)">
            <template slot-scope="scope">
              <el-switch @change="changeKG(scope.row)" v-model="scope.row.myis_status"></el-switch>
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作" width="180">
            <template slot-scope="scope">
              <div class="flex">
                <el-button v-if="scope.row.parent_level >= 0" size="small" type="text" @click="tabEdit(scope.row)">编辑</el-button>
                <el-button v-if="scope.row.parent_level ==3 && scope.row.zpsite_type==1" size="small" type="text" @click="tabEdit(scope.row)">关联智联</el-button>
                <el-button v-if="scope.row.parent_level != 3" size="small" type="text" @click="addChild(scope.row)">添加</el-button>
                <el-button v-if="scope.row.parent_level != 0" size="small" type="text" @click="tabDel(scope.row)">删除</el-button>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
        <el-pagination class="fenye" @size-change="this.handleSizeChange" @current-change="this.handleCurrentChange"
          :current-page="this.biaobaiqiangPage" :page-size="10" :page-sizes="[10, 15, 20, 30]"
          layout="total,sizes, prev, pager, next, jumper" :total="this.total"></el-pagination>
      </div>
    </div>
    <!-- 添加分类 -->
    <el-dialog title="添加分类" :visible.sync="addDialogVisible" width="700px" :before-close="addHandleClose">
      <div class="myAddForm">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="demo-addForm">
          <el-row>
            <el-col :span="20">
              <el-form-item label="分类名称" prop="title">
                <el-input size="small" placeholder="请输入分类名称" v-model="addForm.title"></el-input>
              </el-form-item>
              <el-form-item v-if="this.isAdd == true" label="内部编码" prop="code">
                <el-input size="small" placeholder="请输入内部编码" v-model="addForm.code"></el-input>
              </el-form-item>
              <el-form-item  label="排序" prop="sort">
                <el-input size="small" placeholder="请输入排序" v-model="addForm.sort"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-radio-group v-model="addForm.is_status">
                  <el-radio :label="1">开启</el-radio>
                  <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="this.isAdd==false && addForm.zpsite_type==1">
            <el-col :span="20">
              <el-form-item label="关联智联">
                <!-- 智联树形结构 -->
                <el-tree
                    :data="zhilianTree"
                    :props="defaultProps"
                    show-checkbox
                    node-key="id"
                    ref="zhilianTree"
                    :default-expanded-keys="[2736]"
                    :default-checked-keys="defaultCheckedKeys"
                ></el-tree>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item>
                <el-button size="small" type="primary" @click="AddOnSubmit('addForm')">提交</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    <input type="file" name="companyLogo" id="file0" class="displayN" multiple="multiple" @change="companyLogo($event)"
      ref="fileInputList" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["tabShopIndex", "biaobaiqiangPage",
      "biaobaiqiangPageSize",])
  },
  watch: {
    tabShopIndex: function () {
      this.activeName = this.tabShopIndex;
      console.log(this.activeName);
      this.getData();
    },
    biaobaiqiangPage: function (page) {
      this.$store.commit("biaobaiqiangPage", page);
      this.getData();
    },
    biaobaiqiangPageSize: function (pageSize) {
      this.$store.commit("biaobaiqiangPageSize", pageSize);
      this.getData();
    },
  },
  data() {
    return {

      queryTemp:"",//查找暂存

      activeName: "1",
      searchForm: {
        pid: "",
        status: "",
        keyword: ""
      },
      tableData: [],
      addDialogVisible: false,
      addForm: {
        title: "",
        is_status: 0,
        code:"",
      },
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        is_show: [{ required: true, message: "请选择状态", trigger: "change" }],
        code: [{ required: true, message: "请输入内部编码", trigger: "blur" }],
      },
      zhilianTree: [], // 智联树形数据
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      defaultCheckedKeys: [], // 默认勾选的节点
      imgStatus: "",
      imgFile: "",
      id: "",
      total: 0,
      isAdd: false,
      row: null,
    };
  },
  created() {
    this.$store.commit("biaobaiqiangPage", 1);
    this.$store.commit("biaobaiqiangPageSize", 10);
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$api.jobcategorylist({
        page: this.biaobaiqiangPage,
        pagesize: this.biaobaiqiangPageSize,
        parent_id: 0,
      });
      console.log(res);
      this.tableData = res.list ? res.list : [];
      this.total = res.total
      this.tableData.forEach(ele => {
        ele.myis_status = ele.is_status == 1 ? true : false;
        ele.myis_child = ele.is_child == 1 ? true : false;
      })
    },
    async reloadBeginRow(){
      this.$refs.myTable2.reloadTreeExpand(this.tableData[0])
      this.$refs.myTable2.reloadTreeExpand(this.tableData[1])
    },
    async setAllNodeExpand(){
      this.$refs.myTable2.setTreeExpand(this.tableData[0],true)
      this.$refs.myTable2.setTreeExpand(this.tableData[1],true)
    },
    async loadChildrenMethod({ row }) {
      // 异步加载子节点
      if (row.parent_level==0){
        const res = await this.$api.jobcategorylist({
          page: 1,
          pagesize: 1000,
          parent_id: row.id,
          keyword: this.queryTemp,
        });
        res.list.forEach(ele => {
          ele.myis_status = ele.is_status == 1 ? true : false;
          ele.myis_child = ele.is_child == 1 ? true : false;
        })
        return res.list
      }else {
        const res = await this.$api.jobcategorylist({
          page: 1,
          pagesize: 1000,
          parent_id: row.id,
        });
        res.list.forEach(ele => {
          ele.myis_status = ele.is_status == 1 ? true : false;
          ele.myis_child = ele.is_child == 1 ? true : false;
        })
        return res.list
      }
    },
    // 开关（显示/隐藏）
    async changeKG(row) {
      console.log(row);
      const res = await this.$api.edit_jobcategory(
        {
          ...row,
          is_status: row.is_status == 0 ? 1 : 0,
          parent_id: row.id,
          parent_level: row.parent_level
        },
      );
      if (res.result == 1) {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getData();
      }
    },
    tabsHandleClick(tab) {
      console.log(tab.index);
      this.$store.commit("tabShopIndex", (Number(tab.index) + 1).toString());
    },
    searchOnSubmit() {
      console.log(this.searchForm);
      this.queryTemp = this.searchForm.keyword
      this.biaobaiqiangPage = 1
      // this.getData()
      if (this.searchForm.keyword!=null && this.searchForm.keyword != ""){
        this.reloadBeginRow()
        this.setAllNodeExpand()
      }else {
        this.getData();
      }
    },
    AddFenlei() {
      this.isAdd = true
      this.row = null
      for (const key in this.addForm) {
        this.$set(this.addForm, key, "");
      }
      this.addForm.is_status = 1
      this.addDialogVisible = true;
    },
    addHandleClose() {
      this.addDialogVisible = false;
    },
    tabEdit(row) {
      console.log(row);
      this.isAdd = false;
      this.id = row.id;
      this.row = row;
      this.addForm = { ...row };
      this.addDialogVisible = true;
      this.getZhilianTree(); // 获取智联树形数据
    },
    async getZhilianTree() {
      const res = await this.$api.jobcategory_tree({
        parent_id: 2736,
      });
      this.zhilianTree = res;
      // 设置默认勾选的节点
      if (this.addForm.zhilian_ids) {
        this.defaultCheckedKeys = this.addForm.zhilian_ids.split(',').map(id => parseInt(id));
      }
    },
    addChild(row) {
      this.isAdd = true
      this.row = row
      for (const key in this.addForm) {
        this.$set(this.addForm, key, "");
      }
      this.addForm.is_status = 1
      this.addDialogVisible = true;
    },
    async tabDel(row) {
      console.log(row);
      const res = await this.$api.del_jobcategory({ id: row.id });
      if (res.result == 1) {
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.addDialogVisible = false;
        this.getData();
      } else {
        this.$message.error(res.msg);
      }
    },
    AddOnSubmit(formName) {
      console.log(this.addForm);
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.isAdd) {
            // 新增
            const res = await this.$api.add_jobcategory({
              ...this.addForm,
              parent_id: this.row ? this.row.id : 0,
              parent_level: this.row ? Number(this.row.parent_level) + 1 : 1,
              parent_code: this.row.code,
              zpsite_type: this.row.zpsite_type,
            });
            if (res.result == 1) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.addDialogVisible = false;
              this.getData();
            }
          } else {
            // 编辑
            const checkedNodes = this.$refs.zhilianTree.getCheckedNodes();
            const zhilianIds = checkedNodes.map(node => node.id).join(',');
            const zhilianNames = checkedNodes.map(node => node.title).join(',');

            this.addForm.zhilian_ids = zhilianIds;
            this.addForm.zhilian_names = zhilianNames;

            const res = await this.$api.edit_jobcategory(
              {
                ...this.addForm,
                parent_id: this.row ? this.row.id : 0,
                parent_level: this.row.parent_level
              },
            );
            if (res.result == 1) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.addDialogVisible = false;
              // this.getData();
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除图片
    delImg(val) {
      if (val == "tb") {
        this.$set(this.addForm, "pic", "");
      } else if (this.imgStatus == "dt") {
        this.$set(this.addForm, "big_pic", "");
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.$store.commit("biaobaiqiangPageSize", val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.$store.commit("biaobaiqiangPage", val);
    },
    // 上传图片
    companyList(val) {
      this.imgStatus = val;
      this.$refs.fileInputList.click();
    },
    async companyLogo(event) {
      const that = this;
      var file = event.target.files[0];
      var fileSize = file.size; //文件大小
      var filetType = file.type; //文件类型
      //创建文件读取对象
      // console.log(file);
      if (fileSize <= 10240 * 1024) {
        if (
          filetType == "image/png" ||
          filetType == "image/jpeg" ||
          filetType == "image/gif"
        ) {
          this.imgFile = new FormData();
          this.imgFile.append("image[]", file);
          sessionStorage.setItem("img", 123);
          const res = await that.$api.productUpload(this.imgFile);
          console.log(res.data[0]);
          if (this.imgStatus == "tb") {
            this.$set(this.addForm, "pic", res.data[0]);
          } else if (this.imgStatus == "dt") {
            this.$set(this.addForm, "big_pic", res.data[0]);
          }
          that.$refs.fileInputList.value = "";
        } else {
          this.$message.error("图片格式不正确");
        }
      } else {
        this.$message.error("图片大小不正确");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {}

.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep  .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep  .el-form-item {
      margin-right: 30px;
      margin-bottom: 0;
      vertical-align: middle;
    }
  }

  .tit1 {
    margin-top: 10px;
  }

  .myTable {
    margin-top: 10px;

    ::v-deep  .vxe-table--render-default .vxe-body--column {
      line-height: 0px;
      vertical-align: middle;
    }

    ::v-deep  .vxe-cell--label {
      font-size: 12px;
    }

    ::v-deep  .vxe-cell--title {
      font-size: 12px;
    }

    .flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.myAddForm {
  ::v-deep  .el-select {
    width: 100%;
  }

  ::v-deep  .el-form-item__label {
    font-size: 12px;
    width: 130px !important;
  }

  ::v-deep  .el-form-item__content {
    margin-left: 130px !important;
  }

  ::v-deep  .el-radio__label {
    font-size: 12px;
  }

  ::v-deep  .el-button {
    width: 100%;
  }

  .myImg {
    position: relative;
    width: 60px;
    height: 60px;
    display: inline-block;
    margin-right: 12px;

    .closeBtn {
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;

      .el-button {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    ::v-deep  .image-slot {
      border: 1px solid #ddd;
      border-radius: 4px;
      background-color: #fafafa;
      width: 58px;
      height: 58px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .el-icon-picture-outline {
        font-size: 20px;
      }
    }
  }
}

.displayN {
  display: none;
}
.fenye{
  margin-top: 20px;
}
::v-deep  .vxe-table--render-default .vxe-tree--line{
  bottom: 0.1em !important;
}
</style>
